'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FadeIn = require('./FadeIn');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FadeIn).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-fade-in/lib/index.js
// module id = 45
// module chunks = 35783957827783 70144966829960 246384609461072